export const blockIconsAlertErrorOutline = (
	<span className='material-symbols-outlined'>error_outline</span>
);
